<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
    <path
      d="M8.79191 19.3042H15.1932V13.7812C15.1932 12.1883 15.1337 11.4887 14.9699 10.3573L15.3421 10.2382C15.8482 11.2803 16.0864 11.7715 16.5479 12.5903L16.8307 13.0964H23.5L12.5285 0.695786H11.5013L0.5 13.0964H7.13948L7.42233 12.5903C7.88382 11.7715 8.13689 11.2803 8.62815 10.2382L9.00032 10.3573C8.83657 11.4887 8.79191 12.1883 8.79191 13.7812V19.3042Z"
      fill="currentColor"
    />
  </svg>
</template>
